import React from "react";
import { Text } from "@/components/text";
import type { IQuestion } from "@/apis/exam_papers/types";

interface QuestionNumberSelectorProps {
  questions: IQuestion[];
  currentQuestionIndex: number;
  onQuestionChange: (questionNumber: number) => void;
}

const QuestionNumberSelector: React.FC<QuestionNumberSelectorProps> = ({
  questions,
  currentQuestionIndex,
  onQuestionChange,
}) => {
  const renderQuestionGroups = () => {
    const groups: {
      questions: number[];
      passageId: string | null;
    }[] = [];
    let currentGroup: {
      questions: number[];
      passageId: string | null;
    } | null = null;

    // 그룹 생성 로직
    questions.forEach((question, index) => {
      const passageId = question.passage_id || null;

      if (!currentGroup || currentGroup.passageId !== passageId) {
        // 새 그룹 시작
        currentGroup = { questions: [index], passageId };
        groups.push(currentGroup);
      } else {
        // 기존 그룹에 추가
        currentGroup.questions.push(index);
      }
    });

    return groups.map((group, groupIndex) => {
      if (group.passageId) {
        // Shared passage 그룹
        return (
          <div
            key={`group-${groupIndex}`}
            className="flex gap-1 p-2 bg-blue-50 border-2 border-dashed border-blue-300 rounded"
            title={`Shared Passage Group (ID: ${group.passageId})`}
          >
            {group.questions.map((questionIndex) => (
              <button
                key={questionIndex}
                onClick={() => onQuestionChange(questionIndex + 1)}
                className={`w-10 h-10 rounded flex items-center justify-center cursor-pointer ${
                  currentQuestionIndex === questionIndex
                    ? "bg-blue-600 text-white"
                    : "bg-white hover:bg-blue-100 border border-blue-200"
                }`}
              >
                {questionIndex + 1}
              </button>
            ))}
          </div>
        );
      } else {
        // 개별 문제들
        return group.questions.map((questionIndex) => (
          <div key={questionIndex} className="flex gap-1 p-2 items-center">
            <button
              onClick={() => onQuestionChange(questionIndex + 1)}
              className={`w-10 h-10 rounded flex items-center justify-center cursor-pointer ${
                currentQuestionIndex === questionIndex
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 hover:bg-gray-200"
              }`}
            >
              {questionIndex + 1}
            </button>
          </div>
        ));
      }
    });
  };

  return (
    <div className="mb-6 border-b pb-4">
      <Text className="mb-2 font-medium">Select Question Number:</Text>
      <div className="flex flex-wrap gap-2">{renderQuestionGroups()}</div>
    </div>
  );
};

export default QuestionNumberSelector;
